import {Fragment} from "react";
import pic from "Assets/Images/MediaDaapApp/blog2.png";
import "./style.css";
import API from "Constants/Apis";
import ReducerTypes from "Redux/Types/ReducerTypes";
import {Carousel} from "react-bootstrap";

const EachBlog = ({eachBlog}) => {
    const {caption, subject, medias} = eachBlog;

    return (
        <Fragment>
            <div className="each-useful-content all-media-page w-100 mb-5 bg-shiri">
                {
                    medias.length > 1 ?
                        <div className="slider-box p-0 ">
                            <Carousel
                                variant="dark"
                                fade="true"
                                nextIcon={null}
                                prevIcon={null}
                                interval="2500"
                            >
                                {medias.map((item, i) => {
                                    return (
                                        <Carousel.Item key={i}>
                                            <img className="w-100" src={`${API.BASE_URL_IMAGE}${item.media_path}`}/>
                                        </Carousel.Item>
                                    );
                                })}
                            </Carousel>
                        </div>
                        : <img className="w-100" src={`${API.BASE_URL_IMAGE}${medias[0].media_path}`}/>
                }

                <h6 className="text-center mt-4 px-4">{subject}</h6>
                <p className=" text-justify  about-box p-4">{`${caption.slice(
                    0,
                    150
                )} ....`}</p>
                <span
                    className=" px-3 py-1  btn-white text-success bg-white rounded-pill position-absolute continu-blog ">
          ادامه....
        </span>
            </div>
        </Fragment>
    );
};

export default EachBlog;
